<script>
import moment from 'moment/moment';
import Badge from '@/components/Badge.vue';

export default {
    name: "JobBadge",
    components: {Badge},
    props: {
        activatesAt: {
            type: String,
            required: false
        }
    },
    computed: {
        badge() {
            if(!this.activatesAt) return '';

            const postedDate = moment.utc(this.activatesAt);
            const hoursAgo = moment.utc().diff(postedDate, 'hours');

            if (hoursAgo <= 24) {
                return {class: 'af-badge--just-posted', text: this.$t('label.just_posted')}
            }

            const daysAgo = moment.utc().diff(postedDate, 'days');
            if (daysAgo <= 3) {
                return {class: 'af-badge--new', text: this.$t('label.new')}
            }

            return '';
        }
    }
}
</script>

<template>
    <Badge v-if="badge"
           size="xs"
           class="afu-font-sans afu-font-thin" :class="badge.class">{{ badge.text }}
    </Badge>
</template>
